import React from 'react';
import './PricingPage.css';

function PricingPage() {
  return (
     <div className="pricing-page">
       <div className="pricing-inner">
         <h1 className="pricing-title">Ценоразпис</h1>
         <div className="pricing-image-wrap">
           <img src={process.env.PUBLIC_URL + '/pricing.webp'} alt="Ценоразпис" className="pricing-image" />
         </div>
       </div>
     </div>
  );
}

export default PricingPage;
